<template>
    <div class="matches-tabs">
        <div
            v-for="(tab, index) in availableTabs"
            :key="index"
            :class="[
                'matches-tabs__item',
                { 'matches-tabs__item--active': currentSelectedTabKey === tab.key },
            ]"
            @click="changeTab(tab.key)"
        >
            <img :src="imageUrl(tab.key)"
                class="matches-tabs__item-icon"
            >

            <span v-if="tab.title"
                class="matches-tabs__item-name"
            >
                {{ tab.title }}
            </span>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

import {
    SEASONS,
    SEASON_IDS,
} from '@shared/modules/fan-engagement/constants/sportEventSeasons.ts';

export default {
    name: 'matches-sports-tabs',
    props: {
        selectedKey: {
            type: String,
            default: SEASONS[SEASON_IDS.GLOBAL_TOURNAMENT].key,
        },
    },
    data() {
        return {
            currentSelectedTabKey: SEASONS[SEASON_IDS.GLOBAL_TOURNAMENT].key,
        };
    },
    computed: {
        ...mapGetters('predictorFilters', ['availableTabs']),

        americanFootballIcon() {
            return require('@webapp/assets/icon-american-football.svg');
        },

        footballIcon() {
            return require('@webapp/assets/icon-football.svg');
        },

        globalTournamentIcon() {
            return require('@webapp/assets/icon-global-tournament.svg');
        },
    },
    watch: {
        selectedKey: {
            immediate: true,
            handler(newKey) {
                this.changeTab(newKey);
            },
        },
    },
    methods: {
        changeTab(newKey) {
            if (newKey === this.currentSelectedTabKey) {
                return;
            }

            this.$emit('selectedTabChanged', {
                oldKey: this.currentSelectedTabKey,
                newKey: newKey,
            });

            this.currentSelectedTabKey = newKey;
        },

        imageUrl(key) {
            switch (key) {
                case 'FOOTBALL':
                    return this.footballIcon;

                case 'RUGBY_UNION':
                case 'AMERICAN_FOOTBALL':
                    return this.americanFootballIcon;

                case 'GLOBAL_TOURNAMENT':
                    return this.globalTournamentIcon;

                default:
                    return this.footballIcon;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.matches-tabs {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0 -1rem;
    padding: 0 1rem;
    overflow-x: scroll;

    @include min-width(xl) {
        margin: 0;
        padding: 0;
        overflow: auto;
    }

    &__item {
        min-width: fit-content;
        background: $wild-sand;
        border: 1px solid $light-grey-color;
        border-radius: 16px;
        color: $daintree-color;
        font-size: 15px;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 5px 15px;
        margin-right: 10px;
        cursor: pointer;

        &:last-child {
            margin-right: 0;
        }

        &-icon {
            width: 21px;
            height: 21px;
            margin-right: 7.5px;
        }

        &--active {
            background: $loafer-color;
            border: 1px solid $lime-green-color;
            font-weight: 700;
        }
    }
}
</style>